import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const ParallaxImage = ({ src, alt, className, range = 60 }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const y = useTransform(scrollYProgress, [0, 1], [-range, range]);

  return (
    <div ref={ref} className={className} style={{ overflow: 'hidden' }}>
      <motion.img src={src} alt={alt} style={{ y, width: '100%', height: '120%', objectFit: 'cover', display: 'block' }} />
    </div>
  );
};

export default ParallaxImage;
